/**
 * Entity types allowed as Add Knowledge / EA enrichment anchors.
 * Keep in sync with src/application_enrichment/profiles/loader.py ENRICHMENT_ANCHOR_ALLOWLIST.
 * Matches entity-details Relationships registry types (excludes solution-component).
 */
export const ENRICHMENT_ANCHOR_TYPES = [
  "application",
  "organization",
  "business-capability",
  "business-context",
  "technology-component",
  "interface",
  "platform",
  "initiative",
  "objective",
  "provider",
  "data-object",
];

export const ENRICHMENT_ANCHOR_TYPE_OPTIONS = [
  { value: "application", label: "Application" },
  { value: "organization", label: "Organization" },
  { value: "business-capability", label: "Business capability" },
  { value: "business-context", label: "Business context" },
  { value: "technology-component", label: "Technology component" },
  { value: "interface", label: "Interface" },
  { value: "platform", label: "Platform" },
  { value: "initiative", label: "Initiative" },
  { value: "objective", label: "Objective" },
  { value: "provider", label: "Provider" },
  { value: "data-object", label: "Data object" },
];

export function normalizeEnrichmentAnchorType(raw) {
  return String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/_/g, "-");
}

export function isEnrichmentAnchorType(raw) {
  return ENRICHMENT_ANCHOR_TYPES.includes(normalizeEnrichmentAnchorType(raw));
}

export function enrichmentAnchorTypeLabel(raw) {
  const key = normalizeEnrichmentAnchorType(raw);
  const hit = ENRICHMENT_ANCHOR_TYPE_OPTIONS.find((o) => o.value === key);
  return hit?.label || key.replace(/-/g, " ") || "entity";
}
